import { NgModule, Provider } from '@angular/core';
import { Store } from '@ngrx/store';
import { MODULE_INITIALIZER } from '@spartacus/core';
import { take } from 'rxjs/operators';
import { BaseSiteService } from '../../core/site-context';
import { SOLD_TO_NORMALIZER } from './connector/converters';
import { SoldToNormalizer } from './connector/sold-to-normalizer';
import { AvailableShipTosFacade, SoldToFacade, SoldToOnUserDetailsFacade } from './facades';
import { AvailableShipTosService, SoldToOnUserDetailsService, SoldToService } from './services';
import { SoldToModuleLoaded } from './store/actions';
import { StateWithSoldTo } from './store/sold-to-state';
import { SoldToStoreModule } from './store/sold-to-store.module';

export function soldToBaseModuleInitFactory(store, baseSiteService): () => void {
  const result = () => {
    baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe(() => {
        store.dispatch(new SoldToModuleLoaded());
      });
  };
  return result;
}

const facadeProviders: Provider[] = [
  SoldToService,
  {
    provide: SoldToFacade,
    useExisting: SoldToService,
  },
  AvailableShipTosService,
  {
    provide: AvailableShipTosFacade,
    useExisting: AvailableShipTosService,
  },
  SoldToOnUserDetailsService,
  {
    provide: SoldToOnUserDetailsFacade,
    useExisting: SoldToOnUserDetailsService,
  },
];

const normalizerProviders: Provider[] = [
  {
    provide: SOLD_TO_NORMALIZER,
    useClass: SoldToNormalizer,
    multi: true,
  },
  {
    provide: MODULE_INITIALIZER,
    useFactory: soldToBaseModuleInitFactory,
    deps: [Store<StateWithSoldTo>, BaseSiteService],
    multi: true,
  },
];

@NgModule({
  imports: [SoldToStoreModule],
  providers: [...facadeProviders, ...normalizerProviders],
})
export class SoldToModule {}
